import React, { useState } from 'react'
import Fab from '@mui/material/Fab';
import { GrNext, GrPrevious } from "react-icons/gr";

import banner1 from "../assets/banner/ban-1.jpg"
import banner2 from "../assets/banner/ban-2.jpg"
import banner3 from "../assets/banner/ban-3.jpg"
import banner4 from "../assets/banner/ban-4.jpg"
import banner5 from "../assets/banner/ban-5.jpg"
import banner6 from "../assets/banner/ban-6.jpg"

export const slider = [
    { banner: `${banner1}`, status: true },
    { banner: `${banner2}`, status: true },
    { banner: `${banner3}`, status: true },
    { banner: `${banner4}`, status: true },
    { banner: `${banner5}`, status: true },
    { banner: `${banner6}`, status: true }
]

export default function Hero() {
    const [index, setIndex] = useState(0);
    const { banner } = slider[index];

    const handlePrevSlide = () => {
        setIndex(index === 0 ? slider.length - 1 : index - 1);
    }
    const handleNextSlide = () => {
        setIndex(index === slider.length - 1 ? 0 : index + 1);
    }
    return (
        <div className='sliders'>
            <img src={banner} alt='banner' />
            <Fab size="small" color="success" aria-label="add" onClick={handlePrevSlide} className='prev-btn'>
                <GrPrevious />
            </Fab>
            <Fab size="small" color="success" aria-label="add" onClick={handleNextSlide} className='next-btn'>
                <GrNext />
            </Fab>
        </div>
    )
}
